import { Skeleton } from 'lmcv/components/Skeleton'
import { Avatar } from 'lmcv/components/Avatar'

import * as S from './styled'

function ListSkeleton () {
  return (
    <S.List>
      {Array(5)
        .fill()
        .map((item, index) => (
          <S.Item key={`${item}-${index}`}>
            <S.ItemCol>
              <Avatar loading />
              <S.Info>
                <S.Name>
                  <Skeleton width="130px" height="20px" />
                </S.Name>
                <S.ProjectNameMobile size="mega">
                  <Skeleton width="85px" height="19px" />
                </S.ProjectNameMobile>
                <Skeleton width="75px" height="16px" />
              </S.Info>
            </S.ItemCol>
            <S.ItemCol>
              <div>
                <S.TextProject>
                  <Skeleton width="125px" height="18px" />
                </S.TextProject>
                <S.TextProjectName>
                  <Skeleton width="85px" height="18px" />
                </S.TextProjectName>
              </div>
            </S.ItemCol>
            <S.ItemCol>
              <S.TextDate>
                <Skeleton width="170px" height="18px" />
              </S.TextDate>
            </S.ItemCol>
          </S.Item>
        ))}
    </S.List>
  )
}

export default ListSkeleton
